export default "__VITE_ASSET__BG22SigV__"